// removed by extract-text-webpack-plugin
module.exports = {"SidebarToggler":"SidebarToggler__SidebarToggler__3ZQ-t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidebar/SidebarToggler/SidebarToggler.css
// module id = 135
// module chunks = 0